import { render, staticRenderFns } from "./finalize_form.vue?vue&type=template&id=5848707b&scoped=true&"
import script from "./finalize_form.vue?vue&type=script&lang=js&"
export * from "./finalize_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848707b",
  null
  
)

export default component.exports